import Service from "../Service";
const resource = "PrfCustomerTemplate/";

export default {
  pagination(obj, requestID) {
    return Service.post(resource + "pagination", obj, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
};
